import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import debounce from '@utils/debounce';
const initHomeSlider = (element) => {
    const sliderElement = element.querySelector('.home-slider__slider');
    if (!sliderElement)
        return;
    sliderElement.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        var _a;
        const preloader = document.createElement('div');
        preloader.classList.add('swiper-lazy-preloader');
        preloader.classList.add('swiper-lazy-preloader-white');
        (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(preloader);
    });
    const pagination = (element === null || element === void 0 ? void 0 : element.querySelector('.home-slider__pagination')) || null;
    let isDesktop = false;
    const options = {
        modules: [Pagination, Autoplay, EffectFade],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        autoplay: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
        },
    };
    const autoplayDelay = element.hasAttribute('data-autoplay')
        ? +(element.getAttribute('data-autoplay') || 0)
        : 0;
    if (autoplayDelay) {
        options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        };
    }
    let swiper;
    const initSlider = () => {
        isDesktop = matchMedia('(min-width: 1024px)').matches;
        if (swiper && isDesktop) {
            swiper.destroy();
            delete sliderElement.swiper;
            swiper = null;
        }
        if (!swiper && !isDesktop) {
            swiper = new Swiper(sliderElement, options);
            sliderElement.swiper = swiper;
        }
    };
    window.addEventListener('resize', debounce(initSlider, 300));
    initSlider();
};
document.querySelectorAll('.home-slider').forEach((element) => {
    initHomeSlider(element);
});
